const sms_consent = localStorage.getItem('sms_consent');
const phone_number = localStorage.getItem('phone_number');
setTimeout(function(){
    if(phone_number){
    exponea.update({
        phone: phone_number
    });
  }
const strToBool = (str) => str === 'true';
  if(strToBool(sms_consent) == true){
    exponea.track('consent', {
        action: 'accept', // or 'reject' based on the consent
        category: 'sms',
        valid_until: 'unlimited', // or specify a timestamp
        phone: phone_number,
        timestamp: Math.floor(Date.now() / 1000), // current timestamp in seconds
    }, function(response) {
        console.log('Consent event tracked:', response);
    });
    exponea.update({
        phone: phone_number
    });
  }
localStorage.removeItem('sms_consent');
localStorage.removeItem('phone_number');
},5000);